import axios from "axios";

export const hwApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/hw`, withCredentials: true });

export const hwErr = (err) => {
  const detail = err.response?.data?.detail;
  if (typeof detail === "string") {
    if (detail === "homework_program_required") return "You need the Homework Program (₹99) to generate homework. Get it from the Payments page.";
    if (detail === "homework_program_expired") return "Your program access has expired. Renew it from the Payments page.";
    if (detail === "homework_quota_exhausted") return "You have used all homework assignments in your program. Renew from the Payments page.";
    return detail;
  }
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return "Something went wrong. Please try again.";
};

export const HW_CATEGORIES = [
  { key: "class_6", label: "Class 6" }, { key: "class_7", label: "Class 7" }, { key: "class_8", label: "Class 8" },
  { key: "class_9", label: "Class 9" }, { key: "class_10", label: "Class 10" }, { key: "class_11", label: "Class 11" },
  { key: "class_12", label: "Class 12" }, { key: "jee_main", label: "JEE Main" },
  { key: "jee_advanced", label: "JEE Advanced" }, { key: "neet", label: "NEET UG" },
];

export const fmtDate = (ts) => ts ? new Date(ts * 1000).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit", hour12: true }) : "—";
export const inr = (paise) => `₹${(paise / 100).toLocaleString("en-IN", { minimumFractionDigits: paise % 100 ? 2 : 0 })}`;

export const loadRazorpay = () => new Promise((resolve) => {
  if (window.Razorpay) return resolve(true);
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.onload = () => resolve(true);
  script.onerror = () => resolve(false);
  document.body.appendChild(script);
});
